import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/boule-paille.svg';
import { mapGetters } from 'vuex';
import { EMPTY_PIXEL } from '~/const/images';
export default {
  layout: 'default',
  props: {
    error: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    url() {
      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/");
    },

    backgroundError() {
      return this.error.statusCode === 404 ? 'error-404' : '';
    },

    title() {
      if (this.error.statusCode === 404) {
        return this.$t('title');
      }

      if (this.error.statusCode === 500) {
        return this.$t('title500');
      }

      return '';
    },

    message() {
      if (this.error.statusCode === 404) {
        return this.$t('notfound');
      }

      if (this.error.statusCode === 500) {
        return this.$t('error500');
      }

      return '';
    },

    image() {
      if (this.error.statusCode === 404) {
        return 'https://cdn.maisonsdumonde.com/medias/errors/404/cactus.png';
      }

      if (this.error.statusCode === 500) {
        return 'https://cdn.maisonsdumonde.com/medias/errors/500/dog.gif';
      }

      return EMPTY_PIXEL;
    }

  }),

  mounted() {
    if (this.$cookies.get('debugmdm')) {
      this.$logger.error(this.error);
    }
  }

};